import ReactQuill from 'react-quill';
import { customHrHandler, HR } from './hr';

const Keyboard = ReactQuill.Quill.import('modules/keyboard');
// const bindings = {
//   listEnter: {
//     key: 'Enter',
//     handler(range, context) {
//       // Prevent unnecessary behavior
//       console.log('list formatter', range, context, this.quill);
//       if (!context.empty) return;
//       // add an empty paragraph

//       this.quill.insertHtml(range.index, '<p></p>');
//       this.quill.setSelection(range.index + 1, Quill.sources.SILENT);

//       return true;
//     },
//   },
// };

ReactQuill.Quill.register('modules/keyboard', Keyboard);

export const SPACING_VALUES = [false, '0px', '5px', '10px', '15px', '20px', '25px'];

// Define toolbar options as a constant
export const QUILL_TOOLBAR = quill => ({
  // keyboard: { bindings },
  clipboard: {
    matchVisual: false,
  },
  toolbar: {
    handlers: {
      hr: customHrHandler(quill),
      spacing: function (value) {
        if (value) {
          this.quill.format('spacing', value);
        } else {
          this.quill.format('spacing', false);
        }
      },
    },
    container: [
      [{ header: [1, 2, false] }],
      [{ size: ['10px', '12px', '14px', '16px', '18px', '20px', '22px'] }],
      [{ spacing: SPACING_VALUES }],
      [{ color: ['#00AEC4', 'grey', 'black', 'red'] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote', 'hr'],
      [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
      [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
      ['link', 'clean'],
    ],
  },
});

// Function to register custom Quill configurations
export const getQuill = () => {
  // Register custom size attribute
  const Size = ReactQuill.Quill.import('attributors/style/size');
  Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px', '22px'];
  ReactQuill.Quill.register(Size, true);

  const Parchment = ReactQuill.Quill.import('parchment');

  // Define the custom class attribute for paragraph spacing
  // Import Quill's Parchment module

  // Define a custom Attributor for paragraph spacing as an inline style
  const SpacingStyle = new Parchment.Attributor.Style('spacing', 'margin', {
    scope: Parchment.Scope.BLOCK,
    whitelist: ['0px', '5px', '10px', '15px', '20px', '25px'], // Define allowed spacing values
  });

  // Register the custom Attributor with Quill
  ReactQuill.Quill.register(SpacingStyle, true);

  // Set Quill to log errors only
  ReactQuill.Quill.debug('error');

  // Register custom HR format and icon
  ReactQuill.Quill.register({ 'formats/hr': HR });
  const icons = ReactQuill.Quill.import('ui/icons');
  icons['hr'] = '<i class="fa fa-arrows-h" aria-hidden="true"></i>';

  return ReactQuill;
};
